import { createAction, ActionType, createReducer } from 'typesafe-actions';
import { BASE_URL } from '../../utils/constants';

interface RoutesReducer {
  path: string;
  name: string;
  component: JSX.Element | null;
  check_main_path: boolean;
  root_path: string;
  child_path: string;
}

const initialState: RoutesReducer = {
  path: '/',
  name: '',
  component: null,
  check_main_path: false,
  root_path: '',
  child_path: '',
};

export const CLEAR_PATH = 'RoutesReducer/CLEAR_PATH';
export const SET_PATH = 'RoutesReducer/SET_PATH';

export const clearPath = createAction(CLEAR_PATH)();
export const setPath = createAction(SET_PATH)<{ path: string }>();

export const actions = { setPath, clearPath };
type RoutesReducerActions = ActionType<typeof actions>;

const RoutesReducer = createReducer<RoutesReducer, RoutesReducerActions>(initialState, {
  [CLEAR_PATH]: () => {
    return {
      path: '/',
      name: '',
      component: null,
      check_main_path: false,
      root_path: '',
      child_path: '',
    };
  },
  [SET_PATH]: (state, action) => {
    const path = action.payload.path.replace(/\/admin/g, '');
    const root_path = path.split(`/`)[1];
    const child_path = path.split(`/`)[2];
    return {
      ...state,
      path: path,
      root_path: root_path,
      child_path: child_path ? child_path : '',
      check_main_path: root_path != '' && root_path != 'magazine' ? false : true,
    };
  },
});

export default RoutesReducer;
